import React from 'react'
import "../assets/css/Navbar.css";
import { Link } from "react-router-dom";
import learnberry from '../assets/images/learnberry.png';

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="nav-left">
        <Link to="/" className="nav-link"><img src={learnberry} alt="LEARNBERRY" className="nav-logo" /></Link>
      </div>

      <div className="nav-right">
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/privacy-policy" className="nav-link">Privacy Policy</Link>
        <Link to="/kids-advertise-policy" className="nav-link">Kids Advertise Policy</Link>
      </div>
    </nav>
  )
}
